
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 639.97 639.97"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Lense"}},[_c('circle',{attrs:{"cx":"319.98","cy":"319.98","r":"319.98","fill":"#efefef"}}),_c('g',{staticClass:"outer rotate-center",staticStyle:{"transform-box":"fill-box"},attrs:{"id":"Outer","data-name":"Outer Lense"}},[_c('circle',{attrs:{"cx":"319.98","cy":"319.98","r":"266.15","fill":"#03508c"}}),_c('circle',{staticClass:"outer-highlight",attrs:{"cx":"266.24","cy":"266.24","r":"95.15","fill":"#71c4ea"}})]),_c('g',{staticClass:"inner rotate-center",staticStyle:{"transform-box":"fill-box"},attrs:{"id":"Inner","data-name":"Inner Lense"}},[_c('circle',{attrs:{"cx":"319.98","cy":"319.98","r":"138.17","fill":"#0d3e66"}}),_c('circle',{attrs:{"cx":"384.12","cy":"268.01","r":"28.61","fill":"#d2d4d4","opacity":".47"}})])])])])])
          )
        }
      }
    